import type React from 'react';

import { Button, Separator } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core-react/i18n';

import { SocialProofSunrise } from '#src/app/pages/petitionDetails/shared/components';
import { useNextStepButtonAction } from '#src/app/pages/petitionDetails/shared/hooks';

import { SignatureStatsActiveContainer } from '../stats/signatureStatsSunrise';

export const SideSignedPromotableContainer: React.FC = () => {
	const {
		data: { comboLink },
		action: { handleNextStepClick },
	} = useNextStepButtonAction();

	return (
		<div className="flex flex-col gap-6">
			<SignatureStatsActiveContainer />
			<Separator orientation="horizontal" className="border-stroke-weak" />
			<SocialProofSunrise />
			<Button
				variant="primary"
				as="a"
				href={comboLink}
				onClick={handleNextStepClick}
				data-qa="signed-petition-combo-cta"
				className="w-full"
			>
				<Translate value="fe.pages.petition_update.combo_action_button_label" />
			</Button>
		</div>
	);
};
